var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.168 10.331V1.43H7.31403L7.30603 10.331H5.88403V0.715C5.88403 0.32 6.20403 0 6.59903 0H25.883C26.278 0 26.598 0.32 26.598 0.715V10.331H25.168Z",
    fill: "#0077B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.085 12.0291H2.002C0.898 12.0291 0 12.9011 0 13.9731V22.4531C0 23.5251 0.898 24.3961 2.002 24.3961H3.332V21.2511C3.332 20.6221 3.842 20.1121 4.471 20.1121H28.012C28.641 20.1121 29.151 20.6221 29.151 21.2511V24.3961H31.086C32.19 24.3961 33.087 23.5251 33.087 22.4531V13.9731C33.086 12.9011 32.189 12.0291 31.085 12.0291Z",
    fill: "#0077B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5719 22.199H5.90995C5.51495 22.199 5.19495 22.519 5.19495 22.914V25.286C5.19495 25.681 5.51495 26.001 5.90995 26.001H26.5719C26.9669 26.001 27.2869 25.681 27.2869 25.286V22.914C27.2869 22.518 26.9669 22.199 26.5719 22.199Z",
    fill: "#0077B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.522 9.32893H10.732C10.337 9.32893 10.017 9.00893 10.017 8.61393C10.017 8.21893 10.337 7.89893 10.732 7.89893H21.522C21.917 7.89893 22.237 8.21893 22.237 8.61393C22.237 9.00893 21.917 9.32893 21.522 9.32893Z",
    fill: "#0077B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.522 5.30988H10.732C10.337 5.30988 10.017 4.98988 10.017 4.59488C10.017 4.19988 10.337 3.87988 10.732 3.87988H21.522C21.917 3.87988 22.237 4.19988 22.237 4.59488C22.237 4.98988 21.917 5.30988 21.522 5.30988Z",
    fill: "#0077B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.086,
    height: 26.001,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.5453da2ebcd264866b58136a28d0656f.svg";
export { ForwardRef as ReactComponent };